export enum ZIndex {
    TOAST = 99999, //Mikołaj: do not use this value outside of ToastContainer and do not create higher values
    MODAL = 10005,
    HIGHCHARTS_TOOLTIP = 100,
    LOCKED_CHART = 30
}
